import React, { useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { Button } from "primereact/button";
import localeText from "../../../../locale";
import { formatPrice } from "../../../../utilities/formatPrice";
import ThankyouCard from "./ThankyouCard";
import { usePayment } from "../Checkout/context/PaymentContext";

export const formatAddress = (order) => {
  return `${order.address ? order.address + ", " : ""}${order.number ? order.number + ", " : ""}${
    order.district ? order.district + ", " : ""
  }${order.city ? order.city + ", " : ""}${order.state ? order.state + ", " : ""}${
    order.postalCode ? order.postalCode + ", " : ""
  }${order.country ? order.country : ""}`;
};

const ThankYouPage = ({ order, currencyCodeUser, amountTransfer, amountToPayWithCreditCard }) => {
  const history = useHistory();
  const location = useLocation();
  const { currencyFormat } = usePayment();

  useEffect(() => {
    window.scrollTo(0, 0);
    console.log(order);
  }, []);

  const isFringeBenefitsPage = location?.pathname?.toLowerCase()?.includes("fringe");

  const handleRedicrectToMyPurchases = () => {
    history.push(
      isFringeBenefitsPage ? "/dashboard-purchases-fringe-benefit" : "/dashboard-purchases"
    );
  };

  const handleRedicrectToHome = () => {
    history.push(isFringeBenefitsPage ? "/fringe-benefits?search=ALL&currency=ALL&area=ALL" : "/");
  };

  const amountShipment = order?.amountShipment ? order?.amountShipment : 0;
  const platformFee = order?.amountToPlatform ? order?.amountToPlatform : 0;
  const cashback = order?.cashback ? order?.cashback : 0;

  const subtotal = isFringeBenefitsPage ? order?.totalOrder : order?.amountOrder;

  const totalPrice = subtotal + amountShipment + platformFee;

  const getCurrencySymbol = () => {
    if (isFringeBenefitsPage) {
      return currencyFormat[order?.fringeBenefit?.currency] || order?.fringeBenefit?.currency || "";
    }
    return currencyFormat[order?.itens?.[0]?.product?.currency] || currencyCodeUser || "";
  };

  const currencySymbol = getCurrencySymbol();

  return (
    <div className="flex flex-column mt-6 mb-8">
      <div className="text-center mb-4">
        <div className="font-bold text-2xl" style={{ color: "#46A748" }}>
          {localeText("paymentFinished")}
        </div>

        <div className="text-sm mt-2">{localeText("yourOrderWillBeReady")}</div>
      </div>

      {/* Card de Resumo do Pagamento */}
      <div
        className="card border-none mb-4"
        style={{ backgroundColor: "#ffffff", boxShadow: "0px 0px 40px  #5F58521A" }}
      >
        <div className="font-bold" style={{ color: "#344563" }}>
          {localeText("paymentDone")}
        </div>
        <hr className="my-4"></hr>
        <div className="flex flex-column gap-3" style={{ color: "#344563" }}>
          {/* Subtotal*/}
          <div className="flex justify-content-between">
            <div className="text-sm font-bold">{localeText("subtotal")}</div>
            <div className="text-sm font-semibold">
              {currencySymbol} {formatPrice(subtotal)}
            </div>
          </div>

          {/* Frete */}
          {amountShipment > 0 && (
            <div className="flex justify-content-between">
              <div className="text-sm font-bold">{localeText("shippingInfo")}</div>
              <div className="text-sm font-semibold">
                {currencySymbol} {formatPrice(amountShipment)}
              </div>
            </div>
          )}

          {/* Taxa da Plataforma */}
          {platformFee > 0 && (
            <div className="flex justify-content-between">
              <div className="text-sm font-bold">{localeText("platformFee")}</div>
              <div className="text-sm font-semibold">
                {currencySymbol} {formatPrice(platformFee)}
              </div>
            </div>
          )}
        </div>
        <hr className="my-4"></hr>
        <div className="flex justify-content-between" style={{ color: "#344563" }}>
          <div className="text-sm font-bold">{localeText("totalAmount")}</div>
          <div className="font-bold">
            {currencySymbol} {formatPrice(totalPrice)}
          </div>
        </div>
        <hr className="my-4"></hr>
        {/* Cashback */}
        {cashback > 0 && (
          <>
            <div className="flex justify-content-between">
              <div className="text-sm font-medium" style={{ color: "#344563" }}>
                Cashback
              </div>
              <div className="text-xs" style={{ color: "#46A748" }}>
                + {currencySymbol} {formatPrice(cashback)}
              </div>
            </div>
            <div className="text-xs mt-2" style={{ color: "#7A869A" }}>
              Será disponibilizado na sua carteira após a confirmação da sua compra.
            </div>
          </>
        )}
      </div>

      <div
        className="card border-none mb-4"
        style={{ backgroundColor: "#ffffff", boxShadow: "0px 0px 40px  #5F58521A" }}
      >
        <div>
          <div className="font-bold" style={{ color: "#344563" }}>
            {localeText("orderDetailsCart")}
          </div>
        </div>
        <div className="text-sm font-light mt-2">
          {localeText("someItensMightBeDeliveredSeparately")}
        </div>
        <hr></hr>
        <div className="flex flex-column gap-4">
          {isFringeBenefitsPage ? (
            <ThankyouCard item={order} currencyFormat={currencyFormat} />
          ) : (
            <>
              {order?.itens?.map((item) => (
                <ThankyouCard key={item?.id} item={item} currencyFormat={currencyFormat} />
              ))}
            </>
          )}
        </div>
      </div>

      <div
        className="card border-none mb-4"
        style={{ backgroundColor: "#ffffff", boxShadow: "0px 0px 40px  #5F58521A" }}
      >
        <div style={{ color: "#344563" }}>
          <div className="font-bold">{localeText("requiredUserInfo")}</div>
          <div className="text-sm my-2" style={{lineHeight: "1.5"}}>
            {order?.buyer?.firstname} {order?.buyer?.surname}
            <br />
            {localeText("phone")}: {order?.buyer?.phoneNumber}
            <br />
            {localeText("documentNumber")}: {order?.buyer?.documentNumber}
            <br />
          </div>
          <div className="text-sm font-light" style={{ color: "#7A869A" }}>
            {formatAddress(order || {})}
          </div>
        </div>
      </div>

      <div className="flex justify-content-start gap-2">
        <Button
          label={localeText("backToHomePage")}
          outlined
          className="py-3 px-4 border-round-lg"
          icon="pi pi-arrow-left"
          style={{ color: "#28AB69" }}
          onClick={handleRedicrectToHome}
        />
        <Button
          label={localeText("goToMyShoppings")}
          style={{ color: "#208C56", backgroundColor: "#D9F7EC80" }}
          className="py-3 px-4 border-none border-round-lg"
          onClick={handleRedicrectToMyPurchases}
        />
      </div>
    </div>
  );
};

export default ThankYouPage;
